import React from 'react';
import type { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'atom-components/error-message-from-hook-form';
import Checkbox from 'atom-components/form-fields-for-hook-form/checkbox';
import SystemErrorAlert from 'feature-components/system-error-alert';
import type { BaseTag } from 'services/assist-api/entities/tag/tags';
import styles from './attention-reasons.module.scss';

type Props = {
  canEditMark: boolean;
  attentionReasons: BaseTag[];
};

export default function AttentionReasons({ canEditMark, attentionReasons }: Props): ReactElement {
  const { control, formState, setValue } = useFormContext();

  return (
    <div className={styles.attentionReasonsWithError}>
      <div>
        {attentionReasons.length > 0 ? (
          <ul className={styles.attentionReasons}>
            {attentionReasons.map((attentionReason, index) => (
              <li key={attentionReason.id} className={styles.attentionReason}>
                <Checkbox role="checkbox">
                  <Checkbox.Input
                    id={`tag-${attentionReason.id}`}
                    control={control}
                    name={`attentionReasons.${index}.checked`}
                    role="checkbox"
                    disabled={!canEditMark}
                    onChange={(): void => setValue('hasAskedToFlagForAttention', false)}
                  />
                  <Checkbox.Label htmlFor={`tag-${attentionReason.id}`}>
                    {attentionReason.name}
                  </Checkbox.Label>
                </Checkbox>
              </li>
            ))}
          </ul>
        ) : (
          <SystemErrorAlert>No attention reasons have been set up.</SystemErrorAlert>
        )}
      </div>
      {formState.errors.attentionReasons && (
        <ErrorMessage
          errors={formState.errors}
          name="attentionReasons.root"
          className={styles.errorMessage}
        />
      )}
    </div>
  );
}
